import { createAction } from '@reduxjs/toolkit';
import { SheetGroupsCommand } from '../../../types/commands/sheetGroupsCommands/sheetGroupCommands';
import { SheetsCommand } from '../../../types/commands/common';

export const handleSheetOperations = createAction<SheetsCommand>(
  'sheetsManager/operation'
);
